import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectPartnumbersComponent } from './components/project-partnumbers/project-partnumbers.component';
import {ProjectPartnumbersService} from "@catmodels/project-partnumbers/services/project-partnumbers.service";
import {ProjectServiceService} from "@catmodels/project-partnumbers/services/project-service.service";
import {ButtonModule, DataTableModule} from "primeng/primeng";
import {UIBaseModule} from "@catui/ui-base.module";
import {UIFormModule} from "@catuiform/ui-form.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ProjectAppSelectionsComponent} from "@catmodels/project-partnumbers/components/project-app-selections/project-app-selections.component";
import {ExplorerModule} from "@catmodules/widgets/explorer/explorer.module";
import {RouterModule} from "@angular/router";
import { ProjectUnitPartnumbersComponent } from './components/project-unit-partnumbers/project-unit-partnumbers.component';
import {ProjectAppSelectionsService} from "@catmodels/project-partnumbers/services/project-app-selections.service";
import { ModifyAppSelectionComponent } from './components/modify-app-selection/modify-app-selection.component';
import {AppBundleService} from "@catmodels/project-partnumbers/services/app-bundle.service";
import {AppSelectionsService} from "@catmodels/project-partnumbers/services/app-selections.service";
import { AppTemplateFormComponent } from './components/app-template-form/app-template-form.component';
import {AppTemplateService} from "@catmodels/project-partnumbers/services/app-template.service";

@NgModule({
  entryComponents: [
    ModifyAppSelectionComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DataTableModule,
    UIBaseModule,
    UIFormModule,
    ButtonModule,
    ReactiveFormsModule,
    ExplorerModule,
  ],
  providers: [
    ProjectPartnumbersService,
    ProjectServiceService,
    ProjectAppSelectionsService,
    AppSelectionsService,
    AppBundleService,
    AppTemplateService
  ],
  declarations: [
    ProjectPartnumbersComponent,
    ProjectAppSelectionsComponent,
    ProjectUnitPartnumbersComponent,
    ModifyAppSelectionComponent,
    AppTemplateFormComponent,
  ]
})
export class ProjectPartnumbersModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-partnumbers/project-partnumbers.module.ts